import React, { useState } from "react";
import AdminHOC from "../../../../components/shared/HOC/AdminHOC";
import CustomInput from "../../../../components/shared/Input/Custom-Input";
import CustomTab from "../../../../components/shared/tab/TabComponent";
import CommonTable from "../../../../components/shared/table/Table";
import useGroupKpiReport from "../../../../hooks/GroupHooks/useGroupReport";
import { groupReportsColumns } from "../../../../assets/constants/admin/groupReport";
import CustomButton from "../../../../components/shared/button/CustomButton";
import { downloadGroupReport } from "../../../../service/AdminService/groupService";
import { useNavigate, useSearchParams } from "react-router-dom";

const tabList = [
  { key: "active", label: "Active Groups" },
  { key: "inactive", label: "Inactive Groups" },
];

const GroupReportTable = () => {
  const [searchParams] = useSearchParams();

const defaultStatus = searchParams.get("status") || "active";

const [groupStatus, setGroupStatus] = useState(defaultStatus);
  const [searchText, setSearchText] = useState("");
  const [exportLoading, setSetExportLoading] = useState(false);

  const navigate = useNavigate();
  const { data, loading, paginationConfig, handlePageChange } =
    useGroupKpiReport({
      groupStatus,
      searchText,
    });

  const handleViewGroupClick = (record) => {
    navigate(`/group-history/${record.groupId}`, {
      state: { name: record.groupName }
    });
  }

  const handleExportReport = async () => {
    setSetExportLoading(true);
    try {
      const params = {
        isGroupActive: groupStatus === "active",
        search: searchText || "",
        sortDir: "DESC",
      };

      const res = await downloadGroupReport(params);

      if (!res.success) {
        console.error(res.message);
      }
    } catch (error) {
      console.error("Download failed:", error);
    }
    setSetExportLoading(false);
  };

  return (
    <div className="p-6 flex flex-col border border-[#E8E8E8] rounded-[10px] shadow-[0px_0px_6px_0px_rgba(0,0,0,0.05)]">
      <div className="flex justify-between items-center pb-5">
        <p className="text-[#E74860] text-[1.75rem] font-normal">
          Group Report
        </p>
      </div>
      <div className="flex justify-between items-center">
        <CustomTab activeKey={groupStatus} entries={tabList}  
        onChange={(key) => {
        setGroupStatus(key);
        setSearchText("");
        }} />

        <div className="flex gap-2">
          <CustomInput
            key={groupStatus} 
            placeholder="Search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <CustomButton disabled={exportLoading}  onClick={handleExportReport}>
            Export
          </CustomButton>
        </div>
      </div>

      <CommonTable
        columns={groupReportsColumns}
        data={data}
        loading={loading}
        showLoader={loading}
        pagination={paginationConfig}
        onChange={handlePageChange}
        scroll={{ x: "max-content" }}
        rowClickable={true}
        settingModalDataFunction={handleViewGroupClick}
        hover={true}
        rowKey={(record) => record.userId}
        serverSide={true}
      />
    </div>
  );
};

export default AdminHOC(GroupReportTable);
